import BuilderSegment from './builder-segment.vue'
import BuilderSummary from './builder-summary.vue'

const __default__ = {
  provide() {
    return {
      store: this.store,
      schema: this.schema
    }
  },
  props: {
    store: {type: Object, required: true},
    schema: {type: Array, required: true}
  },
  emits: ['update'],
  data() {
    return {
      segments_validity: Array(this.schema.length).fill(true)
    }
  },
  computed: {
    valid () {
      return this.segments_validity.indexOf(false) === -1
    }
  },
  methods: {
    async onUpdate(prop) {  
      // in some cases, for example in dropdown
      // change event is fired before store tracks
      // change (before store watcher is called)
      // so we delay saving to next tick
      // TODO: fix store watcher if possible
      this.$emit('update', prop)
      if (this.valid) {
        await this.store.save()
      }
    }
  }
}


export default /*@__PURE__*/Object.assign(__default__, {
  __name: 'builder',
  setup(__props, { expose: __expose }) {
  __expose();


const __returned__ = { BuilderSegment, BuilderSummary }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})